import SiteLogo from "../../Assets/svgs/Sitelogo1";


export default function MaintenancePage() {
  return (
    <div className="bg-gray-200 w-full px-8 md:px-0 h-screen flex flex-col items-center justify-center gap-4">
      <span className="rounded-xl">
        <SiteLogo />
      </span>
      <p className="text-[calc(1.2rem+1vw)] text-center font-bold  text-primary">
        Our platform is undergoing an upgrade{" "}
      </p>
      <p className="text-[calc(0.6rem+1vw)] text-primary border-b-2 text-center">
        Please check this page in a few hours{" "}
      </p>
    </div>
  )
}